import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { GenericDeleteModal } from 'src/js/component/generic-delete-modal';
import { notificationHandler } from 'src/js/notification/notification-handler';

interface Props {
  onApply: () => void;
  onCancel?: VoidFunction;
}

export const DeleteBannerConfirmModal: React.FunctionComponent<Props> = ({ onApply, onCancel }) => {
  const { t } = useTranslation();

  const handleDelete = () => {
    return apiClientWithoutHandler.genericController.delete(APIPath.banner).then((res: any) => {
      notificationHandler(res, null, t('security.banner.notifications.deleteErrorMsg'), t);
      if (res.ok) {
        onApply();
      }
      return res;
    });
  };

  return (
    <GenericDeleteModal
      title={t('security.banner.modal.delete.title')}
      body={t('general.cannotUndo')}
      onCancel={onCancel}
      onDelete={handleDelete}
      itemsToDelete={[]}
    />
  );
};
